import { ExLoader } from '@boomi/exosphere';
import { useAnomalyDashboard } from './AnomalyProvider';
import AnomalyDonutChart from './AnomalyDonutChart';
import AnomalyBarChart from './AnomalyBarChart';

const AnomalyChartWrapper = () => {
    const { isLoadingData } = useAnomalyDashboard();
    return isLoadingData ? (
        <ExLoader />
    ) : (
        <span className="chart-area">
            <AnomalyBarChart />
            <AnomalyDonutChart />
        </span>
    );
};

export default AnomalyChartWrapper;
